import React from 'react';
import { IconContainer } from '../../iconContainer';
import { PlusIcon } from '../../../../../icons/plus';
import { AvatarIcon } from '../../../../../icons/avatar';
import { Image } from '../../../../image';
import { mergeSx } from '../../../../../utils/sx/merge';
import { getAvatarSizeStyles } from '../../../utils';
import { AvatarTokens } from '../../../const';
import { IMAGE_FALLBACK_SIZE_TO_CONTAINER_SIZE, PLUS_ICON_SIZE_TO_CONTAINER_SIZE } from './const';
import { AvatarImageContentProps } from './model';

export const AvatarImageContent: React.FC<AvatarImageContentProps> = ({
  theme,
  backgroundColor,
  clickAction,
  onClick,
  asset,
  alt = '',
  lazyLoadProps,
}) => {
  const [isLoadingError, setLoadingError] = React.useState(false);

  const plusSize = `calc(${AvatarTokens.Size('100px')} * ${PLUS_ICON_SIZE_TO_CONTAINER_SIZE})`;
  const fallbackIconSize = `calc(${AvatarTokens.Size('100px')} * ${IMAGE_FALLBACK_SIZE_TO_CONTAINER_SIZE})`;

  return (
    <React.Fragment>
      {asset ? (
        <Image
          alt={alt}
          asset={asset}
          lazyLoadProps={lazyLoadProps}
          onError={() => {
            setLoadingError(true);
          }}
          onLoad={() => {
            setLoadingError(false);
          }}
          sx={mergeSx(
            {
              borderRadius: { xs: `${theme.borderRadius.normal}px`, md: `${theme.borderRadius.medium}px` },
              position: 'relative',
              zIndex: 1,
              objectFit: 'cover',
            },
            getAvatarSizeStyles(),
          )}
        />
      ) : null}
      {(!asset || isLoadingError) && (
        <IconContainer
          sx={{
            alignItems: onClick ? 'center' : 'flex-end',
            backgroundColor,
          }}
          theme={theme}
        >
          {clickAction === 'change' ? (
            <PlusIcon sx={{ fontSize: plusSize }} />
          ) : (
            <AvatarIcon
              color="gray middle"
              sx={{
                height: fallbackIconSize,
                maxHeight: fallbackIconSize,
                maxWidth: fallbackIconSize,
                width: fallbackIconSize,
              }}
            />
          )}
        </IconContainer>
      )}
    </React.Fragment>
  );
};
